import * as React from 'react';
import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import { Line } from 'pages/Report/components/Chart';
import { Options } from 'highcharts';
import { useIntl } from 'react-intl';
import ErrorMessage from 'pages/Report/components/ErrorMessage';
import { ApiError } from 'redux/ducks/error';

interface ComponentProps {
  chartOptions: Options;
  isLoading: boolean;
  error: ApiError;
  isGuestType?: boolean;
}

const RegistrationsPerDay: React.FunctionComponent<ComponentProps> = ({
  chartOptions,
  isLoading,
  error,
  isGuestType = false
}) => {
  const intl = useIntl();
  return (
    <Card>
      <CardHeader
        title={
          intl.messages[
            `report.frequency.${
              isGuestType ? 'avgGuestRegistrationsPerDay' : 'avgRegistrationsPerDay'
            }`
          ]
        }
        // Temporarily disabled until text format is agreed on:
        // subheader={ intl.formatMessage({ id: 'report.frequency.avgRegistrationsPerDay.description' }) }
      />
      <CardContent>
        {error ? (
          <ErrorMessage error={error} />
        ) : (
          <Grid container justify={'center'}>
            <Grid item xs={12} md={11}>
              <Line chartOptions={chartOptions} isLoading={isLoading} />
            </Grid>
          </Grid>
        )}
      </CardContent>
    </Card>
  );
};

export default RegistrationsPerDay;
